export class GetErcChecklist {
  static readonly type = '[Erc] GetErcChecklist';
  constructor(public borrowerId: number) {}
}

export class PostErcChecklist {
  static readonly type = '[Erc] PostErcChecklist';
  constructor(public borrowerId: number, public page: string|undefined) {}
}

export class PutErcChecklist {
  static readonly type = '[Erc] PutErcChecklist';
  constructor(public checklistId: number, public borrowerId: number, public page: string|undefined) {}
}
